<template>
  <LoginSection :show-header="true"></LoginSection>
</template>
<script>
import LoginSection from "@/Layout/Login";
export default {
  name:"Login",
  components: {LoginSection}
}
</script>